import React, { useMemo, useState } from "react"
import Input from "@react/shared/ui/Input"
import Popover from "./Popover"
import { matches } from "../lib/search"

const AddProjectPopover = ({ rect, projects, onPick, onClose }) => {
  const [query, setQuery] = useState("")
  const visible = useMemo(() => projects.filter(project => matches(query, project.code, project.name, project.client)).slice(0, 60), [projects, query])

  return (
    <Popover rect={rect} width={320} title={I18n.t("project_planning.projects_view.add")} onClose={onClose}>
      <Input autoFocus variant="search" size="sm" leadingIcon="magnifying-glass" placeholder={I18n.t("project_planning.palette.search_projects")} value={query} onChange={event => setQuery(event.target.value)} />
      <ul className="mt-2 -mx-1 max-h-72 overflow-y-auto">
        {visible.map(project => (
          <li key={project.id}>
            <button type="button" onClick={() => { onPick(project.id); onClose() }} className="w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-left hover:bg-slate-100">
              <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: project.color }} />
              {project.code && <span className="font-mono text-[10.5px] font-semibold text-slate-500 shrink-0">{project.code}</span>}
              <span className="text-[12.5px] text-slate-800 truncate">{project.name}</span>
            </button>
          </li>
        ))}
        {visible.length === 0 && <li className="px-2 py-6 text-center text-[12px] text-slate-400">{I18n.t("project_planning.no_match")}</li>}
      </ul>
    </Popover>
  )
}

export default AddProjectPopover
